import _ from 'lodash'
import { useMemo } from 'react'
import { useGetBalancesQuery, useGetCurrenciesQuery } from '@/store/api/paymentApi'
import { useAppSelector } from '@/store/hooks'
import { selectIsAuthenticated } from '@/store/slices/authSlice'
import type { Currency } from '@/types/payment'

function pickDefaultCurrency(currencies: Currency[]) {
	return _.find(currencies, 'is_default') ?? _.first(currencies)
}

export function useDefaultCurrencyCode(): string {
	const isAuthenticated = useAppSelector(selectIsAuthenticated)
	const { data: currenciesResponse } = useGetCurrenciesQuery()
	const { data: balancesResponse } = useGetBalancesQuery(undefined, { skip: !isAuthenticated })

	return useMemo(() => {
		if (isAuthenticated) {
			const defaultBalance = _.find(balancesResponse?.data, 'is_default') ?? _.first(balancesResponse?.data)

			if (defaultBalance?.currency_code) {
				return defaultBalance.currency_code
			}
		}

		return pickDefaultCurrency(currenciesResponse?.data ?? [])?.currency_code ?? 'USD'
	}, [balancesResponse?.data, currenciesResponse?.data, isAuthenticated])
}

export function useDefaultCurrencyId(): string | undefined {
	const isAuthenticated = useAppSelector(selectIsAuthenticated)
	const { data: currenciesResponse } = useGetCurrenciesQuery()
	const { data: balancesResponse } = useGetBalancesQuery(undefined, { skip: !isAuthenticated })

	return useMemo(() => {
		if (isAuthenticated) {
			const defaultBalance = _.find(balancesResponse?.data, 'is_default') ?? _.first(balancesResponse?.data)

			if (defaultBalance?.currency_id) {
				return defaultBalance.currency_id
			}
		}

		return pickDefaultCurrency(currenciesResponse?.data ?? [])?.id
	}, [balancesResponse?.data, currenciesResponse?.data, isAuthenticated])
}
